// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-r"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 12V5H15.5C15.7761 5 16 5.22386 16 5.5V11.5C16 11.7761 15.7761 12 15.5 12H10M8 12V19M8 12H10M16.5 19V17.7319C16.5 17.5848 16.4352 17.4452 16.323 17.3502L10 12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersRIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-r',
    ref,
    icon: element,
  },
));

LettersRIcon.displayName = 'LettersRIcon';

export default LettersRIcon;
